(function () {
  'use strict';

  var CFG = window.HORIZON_SOCIAL || {};
  var MAX_POPUPS = typeof CFG.maxPopups === 'number' ? CFG.maxPopups : 5;
  var POPUPS_ENABLED = CFG.popups !== false;
  var REVIEWS_ENABLED = CFG.reviews !== false;

  var FIRST_NAMES = ['Ayesha','Fatima','Zainab','Hina','Sana','Mahnoor','Ali','Ahmed','Hassan','Usman','Bilal','Hamza','Faisal','Kamran','Sajid','Naveed','Tariq','Junaid','Shahzaib','Danish','Muneeb','Saad','Rayyan','Ibrahim','Omar','Zohaib','Adnan','Farhan','Noman','Waqas','Laiba','Noor','Areeba','Sidra','Iqra','Mehwish','Bushra','Rabia','Amna','Hafsa'];
  var LAST_NAMES = ['Khan','Ahmed','Malik','Hussain','Raza','Sheikh','Chaudhry','Qureshi','Butt','Ghauri','Siddiqui','Niazi','Awan','Javed','Iqbal','Baig','Shah','Gilani','Yousafzai','Memon','Durrani','Khattak','Abbasi','Tariq','Kazmi','Rizvi','Faruqi','Hashmi','Nazir','Saleem'];
  var CITIES = ['Karachi','Lahore','Islamabad','Rawalpindi','Faisalabad','Multan','Peshawar','Quetta','Hyderabad','Sialkot','Gujranwala','Bahawalpur','Sargodha','Abbottabad','Gujrat','Wah Cantt','Jhelum','Sahiwal','Okara','Mardan'];

  var REVIEW_TITLES = [
    'Excellent quality',
    'Better than expected',
    'Highly recommended',
    'Great value for money',
    'Premium feel',
    'Fast delivery',
    'Very happy with this purchase',
    'Exactly as shown',
    'Outstanding service',
    'Worth every rupee',
    'Superb packaging',
    'My new favorite',
    'Genuine product',
    'Five stars',
    'Stopped my search here'
  ];

  var REVIEW_BODIES = [
    'The {product} arrived yesterday and I am genuinely impressed with the build quality. Feels much more expensive than the price. Packaging was secure and delivery took only 2 days.',
    'Ordered the {product} after comparing a few stores and this was the best decision. Finishing is clean, and it looks exactly like the photos on the site.',
    'My third order from this store and the {product} did not disappoint. Customer support answered my questions on WhatsApp within minutes too.',
    'Really happy with the {product}. Delivery to Lahore was quick and the tracking updates kept me informed the whole time.',
    'For this price, the {product} is unbeatable. Solid feel, no cheap plastic vibes. My brother already asked me to order one for him as well.',
    'The {product} exceeded my expectations. I was worried about ordering online but the quality is genuinely premium.',
    'Received the {product} in perfect condition. The packaging felt like a proper brand experience, not a random courier bag.',
    'I gifted the {product} to my husband and he has not taken it off since. Great purchase, will order again Inshallah.',
    'Honestly surprised by the quality of the {product}. Cash on delivery made it easy to trust, and now I am a regular customer.',
    'The {product} looks even better in person. Photos do not do it justice. Delivery rider was polite and professional too.',
    'Good product, good service. The {product} matched the description exactly and arrived a day earlier than estimated.',
    'I ordered on Friday and got the {product} on Monday in Karachi. Quality checks seem solid, nothing broken or scratched.',
    'Excellent {product}. I have bought similar items from big brands before and this holds up just as well for a fraction of the price.',
    'The {product} is worth every rupee. Minimal, classy, and does not feel heavy at all. Very comfortable for daily use.',
    'If you are thinking about the {product}, just order it. I took the risk and was not disappointed at all.',
    'MashaAllah the {product} is beautiful. My wife loved it as an anniversary gift. Thank you for the quick delivery!',
    'Solid customer service. Had a small question about sizing and they replied within an hour. The {product} itself is top notch.',
    'The {product} arrived in 3 days to Islamabad. Quality is exactly what was shown on the website. Very satisfied.',
    'Best purchase I have made online this year. The {product} feels premium and the price was very fair compared to market rates.',
    'Packaging, delivery, product quality — everything was on point. The {product} is definitely worth recommending to friends.',
    'Bilkul waisa hi product hai jaisa website par dikhaya gaya hai. {product} ki quality bohat achi hai, delivery bhi time par mili.',
    'Main ne {product} order kiya tha aur honestly expected se behtar nikla. Packing bhi secure thi aur delivery bhi fast.',
    'Bohat acha experience raha. {product} ki quality premium hai aur price bhi reasonable hai. Doubt ho to bilkul order kar lein.',
    'Pehli dafa yahan se order kiya tha. {product} bilkul genuine aaya, delivery boy ne cash on delivery par deliver kar diya. Recommended!',
    'Delivery bohat jaldi Lahore pohnch gayi. {product} quality mein top hai, paisa wasool product hai.',
    'Product ki finishing bohat clean hai. {product} dekhne mein expensive lagta hai lekin price affordable hai. Nice!'

  ];

  var STORE_NAME = CFG.storeName || 'Watch Hub';

  function hashStr(s) {
    var h = 2166136261;
    for (var i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  function mulberry32(a) {
    return function () {
      a |= 0;
      a = (a + 0x6d2b79f5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function pick(rng, arr) {
    return arr[Math.floor(rng() * arr.length)];
  }

  function daysAgoDate(rng, maxDays) {
    var bias = rng();
    var days = Math.floor(Math.pow(bias, 1.7) * maxDays);
    var d = new Date();
    d.setDate(d.getDate() - days);
    d.setHours(9 + Math.floor(rng() * 12), Math.floor(rng() * 60), 0, 0);
    if (d.getTime() > Date.now()) d = new Date(Date.now() - Math.floor(rng() * 10800000));
    return d;
  }

  function fmtDate(d) {
    try {
      return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    } catch (e) {
      return d.toDateString();
    }
  }

  // Star distribution derived from a target average (floor 4.5, ceiling ~4.87).
  // p1=1%, p2=1%, p3=3%, p5=avg-3.92, p4=4.87-avg (sums to 100%).
  function distForAvg(avg, total) {
    var a = Math.min(Math.max(avg, 4.5), 4.87);
    var p5 = a - 3.92;
    var p4 = 4.87 - a;
    if (p5 < 0) p5 = 0;
    if (p4 < 0) p4 = 0;
    var c1 = Math.round(0.01 * total);
    var c2 = Math.round(0.01 * total);
    var c3 = Math.round(0.03 * total);
    var c4 = Math.round(p4 * total);
    var c5 = total - c1 - c2 - c3 - c4;
    if (c5 < 0) { c4 += c5; c5 = 0; }
    return [c1, c2, c3, c4, c5];
  }

  function generateReviews(handle, title, imageURL, opts) {
    opts = opts || {};
    var rng = mulberry32(hashStr(handle + '::v2'));
    var count = opts.count > 0 ? opts.count : 60 + Math.floor(rng() * 181);
    var avg = opts.avg > 0 ? opts.avg : 4.7;
    var counts = distForAvg(avg, count);
    var pool = [];
    for (var s = 1; s <= 5; s++) {
      for (var k = 0; k < counts[s - 1]; k++) pool.push(s);
    }
    for (var pi = pool.length - 1; pi > 0; pi--) {
      var pj = Math.floor(rng() * (pi + 1));
      var pt = pool[pi]; pool[pi] = pool[pj]; pool[pj] = pt;
    }
    var reviews = [];
    var usedNames = {};
    for (var i = 0; i < count; i++) {
      var name;
      var guard = 0;
      do {
        name = pick(rng, FIRST_NAMES) + ' ' + pick(rng, LAST_NAMES);
        guard++;
      } while (usedNames[name] && guard < 12);
      usedNames[name] = true;

      var rating = i < pool.length ? pool[i] : 5;
      var body = pick(rng, REVIEW_BODIES).replace(/\{product\}/g, title);
      if (rating <= 3 && rng() < 0.7) {
        body = body.replace(/\.$/, '') + (rating === 3 ? ' — good, but delivery took a bit longer than expected.' : ' — decent, though I expected a little more for the price.');
      }
      var hasPhoto = imageURL && rng() < 0.12;
      reviews.push({
        id: handle + '-r' + i,
        name: name,
        city: pick(rng, CITIES),
        rating: rating,
        title: pick(rng, REVIEW_TITLES),
        body: body,
        date: daysAgoDate(rng, 400),
        verified: rng() < 0.85,
        helpful: Math.floor(rng() * 13),
        photo: hasPhoto ? imageURL : null
      });
    }
    reviews.sort(function (a, b) { return b.date - a.date; });
    return reviews;
  }

  function starsHTML(rating) {
    var out = '<span class="hrev__stars" aria-label="' + rating + ' out of 5 stars">';
    for (var i = 1; i <= 5; i++) {
      out += '<span class="hrev__star' + (i <= rating ? ' is-on' : '') + '">★</span>';
    }
    return out + '</span>';
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function getLocalPending(handle) {
    try {
      return JSON.parse(localStorage.getItem('hrev_pending_' + handle) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveLocalPending(handle, list) {
    var trimmed = list.slice(0, 10);
    try {
      localStorage.setItem('hrev_pending_' + handle, JSON.stringify(trimmed));
    } catch (e) {
      try {
        var lite = trimmed.map(function (p) {
          var c = {};
          for (var k in p) c[k] = p[k];
          c.photo = null;
          return c;
        });
        localStorage.setItem('hrev_pending_' + handle, JSON.stringify(lite));
      } catch (e2) { /* ignore */ }
    }
  }

  function compressImageFile(file, cb) {
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      var max = 480;
      var scale = Math.min(1, max / Math.max(img.width, img.height));
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(img.width * scale));
      c.height = Math.max(1, Math.round(img.height * scale));
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      try { cb(c.toDataURL('image/jpeg', 0.72)); } catch (e) { cb(null); }
    };
    img.onerror = function () { URL.revokeObjectURL(url); cb(null); };
    img.src = url;
  }

  function initReviews() {
    if (!REVIEWS_ENABLED) return;
    var root = document.querySelector('[data-hrev]');
    if (!root) return;

    var handle = root.getAttribute('data-product-handle');
    var title = root.getAttribute('data-product-title');
    var image = root.getAttribute('data-product-image');
    var url = root.getAttribute('data-product-url');

    var listEl = root.querySelector('[data-hrev-list]');
    var summaryEl = root.querySelector('[data-hrev-summary]');
    var countEl = root.querySelector('[data-hrev-count]');
    var sortEl = root.querySelector('[data-hrev-sort]');
    var moreBtn = root.querySelector('[data-hrev-more]');
    var openBtn = root.querySelector('[data-hrev-open-form]');
    var formWrap = root.querySelector('[data-hrev-form-wrap]');
    var form = root.querySelector('#hrev-form');
    var thanks = root.querySelector('[data-hrev-thanks]');
    var ratingInput = root.querySelector('[data-hrev-form-rating]');
    var starPicker = root.querySelector('[data-hrev-star-picker]');
    var submitBtn = root.querySelector('[data-hrev-submit]');
    var photoInput = root.querySelector('[data-hrev-photo]');
    var photoPreview = root.querySelector('[data-hrev-photo-preview]');
    var photoRemove = root.querySelector('[data-hrev-photo-remove]');
    var cancelBtn = root.querySelector('[data-hrev-cancel]');
    var savedPhoto = null;

    function clearPhoto() {
      savedPhoto = null;
      if (photoInput) photoInput.value = '';
      if (photoPreview) { photoPreview.removeAttribute('src'); photoPreview.hidden = true; }
      if (photoRemove) photoRemove.hidden = true;
    }

    var pending = getLocalPending(handle).map(function (p) {
      p.date = new Date(p.date);
      p.pending = true;
      return p;
    });
    var forcedTotal = parseInt(root.getAttribute('data-hrev-total'), 10);
    if (!(forcedTotal > 0)) forcedTotal = 0;
    var forcedRating = parseFloat(root.getAttribute('data-hrev-rating'));
    if (!(forcedRating > 0)) forcedRating = 0;
    if (forcedRating > 0 && forcedRating < 4.5) forcedRating = 4.5;

    function readBlocks() {
      return (window.__HREV_BLOCKS || []).map(function (b, i) {
        var d = new Date(b.date);
        if (isNaN(d.getTime())) d = new Date(Date.now() - (i + 1) * 86400000);
        return {
          id: 'blk-' + b.id,
          name: b.name || 'Customer',
          city: b.city || '',
          rating: parseInt(b.rating, 10) || 5,
          title: b.title || '',
          body: b.body || '',
          date: d,
          verified: b.status === 'verified',
          pending: b.status === 'pending',
          helpful: parseInt(b.helpful, 10) || 0,
          photo: b.photo || null,
          youtube: b.youtube || '',
          fromBlock: true
        };
      });
    }

    var blocks = readBlocks();

    function isDupOfBlock(p) {
      for (var i = 0; i < blocks.length; i++) {
        if (blocks[i].name === p.name && p.body && blocks[i].body === p.body) return true;
      }
      return false;
    }

    function localPending() {
      return pending.filter(function (p) { return !isDupOfBlock(p); });
    }

    function genCount() {
      return forcedTotal > 0 ? Math.max(forcedTotal - blocks.length, 0) : 0;
    }

    var reviews = [];
    function rebuild() {
      reviews = blocks.concat(localPending(), generateReviews(handle, title, image, { count: genCount(), avg: forcedRating }));
    }
    rebuild();
    var visible = 6;
    var sort = 'recent';

    function sorted() {
      var arr = reviews.slice();
      var pinRank = function (r) { return r.fromBlock ? 2 : (r.pending ? 1 : 0); };
      if (sort === 'highest') arr.sort(function (a, b) { return b.rating - a.rating || b.date - a.date; });
      else if (sort === 'lowest') arr.sort(function (a, b) { return a.rating - b.rating || b.date - a.date; });
      else arr.sort(function (a, b) { return pinRank(b) - pinRank(a) || b.date - a.date; });
      return arr;
    }

    function renderSummary() {
      var n = reviews.length;
      if (!n) { summaryEl.innerHTML = ''; return; }
      var sum = 0;
      var dist = [0, 0, 0, 0, 0];
      reviews.forEach(function (r) {
        sum += r.rating;
        dist[5 - r.rating]++;
      });
      var avgVal = forcedRating > 0 ? forcedRating : Math.max(4.5, sum / n);
      var avg = avgVal.toFixed(1);
      var bars = '';
      for (var s = 5; s >= 1; s--) {
        var c = dist[5 - s];
        var pct = Math.round((c / n) * 100);
        bars +=
          '<div class="hrev__bar-row"><span class="hrev__bar-label">' + s + '</span>' +
          '<span class="hrev__bar-track"><span class="hrev__bar-fill" style="width:' + pct + '%"></span></span>' +
          '<span class="hrev__bar-count">' + c + '</span></div>';
      }
      summaryEl.innerHTML =
        '<div class="hrev__avg-block">' +
        '<div class="hrev__avg-num">' + avg + '</div>' +
        starsHTML(Math.round(avgVal)) +
        '<div class="hrev__avg-meta">' + n + ' reviews</div>' +
        '</div><div class="hrev__dist">' + bars + '</div>';
      try {
        window.__HREV_STATS = window.__HREV_STATS || {};
        window.__HREV_STATS[handle] = { count: n, avg: avgVal };
      } catch (e) { /* ignore */ }
    }

    function cardHTML(r) {
      var initials = r.name.split(' ').map(function (w) { return w.charAt(0); }).join('').slice(0, 2).toUpperCase();
      var badge = r.pending
        ? '<span class="hrev__badge hrev__badge--pending">Under moderation</span>'
        : (r.verified ? '<span class="hrev__badge">Verified purchase</span>' : '');
      return (
        '<article class="hrev__card">' +
        '<div class="hrev__card-head">' +
        '<span class="hrev__avatar">' + esc(initials) + '</span>' +
        '<span class="hrev__who"><span class="hrev__name">' + esc(r.name) + '</span>' +
        '<span class="hrev__loc">' + esc(r.city) + ' · ' + fmtDate(r.date) + '</span></span>' +
        '</div>' +
        '<div class="hrev__rating-row">' + starsHTML(r.rating) + badge + '</div>' +
        (r.title ? '<h4 class="hrev__card-title">' + esc(r.title) + '</h4>' : '') +
        '<p class="hrev__body">' + esc(r.body) + '</p>' +
        (r.photo ? '<div class="hrev__photo"><img src="' + esc(r.photo) + '" alt="Customer photo" loading="lazy" width="80" height="80"></div>' : '') +
        (r.youtube && /^https?:\/\//i.test(r.youtube) ? '<a class="hrev__yt" href="' + esc(r.youtube) + '" target="_blank" rel="noopener">&#9654; Watch video</a>' : '') +
        '<div class="hrev__foot"><button type="button" class="hrev__helpful" data-helpful>Helpful (' + (r.helpful || 0) + ')</button></div>' +
        '</article>'
      );
    }

    function renderList() {
      var arr = sorted();
      if (!arr.length) {
        listEl.innerHTML = '<p class="hrev__empty">Abhi tak koi review nahi. Pehle reviewer banain!</p>';
        moreBtn.hidden = true;
        return;
      }
      var slice = arr.slice(0, visible);
      listEl.innerHTML = slice.map(cardHTML).join('');
      countEl.textContent = 'Showing ' + slice.length + ' of ' + arr.length + ' reviews';
      moreBtn.hidden = visible >= arr.length;
    }

    function render() {
      renderSummary();
      renderList();
    }

    if (sortEl) {
      sortEl.addEventListener('change', function () {
        sort = sortEl.value;
        visible = 6;
        renderList();
      });
    }
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        visible += 6;
        renderList();
      });
    }
    var lb = null;
    function lockScroll(on) {
      document.documentElement.style.overflow = on ? 'hidden' : '';
      var pw = document.querySelector('.page-wrapper');
      if (pw) pw.style.overflowY = on ? 'hidden' : '';
    }
    function closeLightbox() {
      if (!lb) return;
      lb.classList.remove('is-open');
      lockScroll(false);
    }
    function openLightbox(img) {
      if (!img) return;
      if (!lb) {
        lb = document.createElement('div');
        lb.className = 'hrev-lightbox';
        lb.innerHTML = '<button type="button" class="hrev-lightbox__close" aria-label="Close">&times;</button><img alt="Customer photo">';
        document.body.appendChild(lb);
        lb.addEventListener('click', function (ev) {
          if (ev.target === lb || ev.target.closest('.hrev-lightbox__close')) closeLightbox();
        });
        document.addEventListener('keydown', function (ev) {
          if (ev.key === 'Escape') closeLightbox();
        });
      }
      var full = lb.querySelector('img');
      full.src = img.currentSrc || img.src;
      lb.classList.add('is-open');
      lockScroll(true);
    }

    listEl.addEventListener('click', function (e) {
      var ph = e.target.closest('.hrev__photo');
      if (ph) {
        openLightbox(ph.querySelector('img'));
        return;
      }
      var b = e.target.closest('[data-helpful]');
      if (!b || b.disabled) return;
      var m = b.textContent.match(/\((\d+)\)/);
      if (m) b.textContent = 'Helpful (' + (parseInt(m[1], 10) + 1) + ')';
      b.disabled = true;
      b.classList.add('is-on');
    });

    if (openBtn && formWrap) {
      openBtn.addEventListener('click', function () {
        formWrap.hidden = !formWrap.hidden;
        if (!formWrap.hidden) {
          if (form && form.hidden) {
            form.hidden = false;
            if (thanks) thanks.hidden = true;
            clearPhoto();
          }
          formWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var f = root.querySelector('#hrev-name');
          if (f) setTimeout(function () { f.focus(); }, 350);
        }
      });
    }
    if (cancelBtn && formWrap) {
      cancelBtn.addEventListener('click', function () {
        formWrap.hidden = true;
      });
    }

    if (photoInput) {
      photoInput.addEventListener('change', function () {
        var file = photoInput.files && photoInput.files[0];
        if (!file) return;
        var hint = root.querySelector('[data-hrev-upload-hint]');
        if (!/^image\//.test(file.type) || file.size > 5 * 1024 * 1024) {
          photoInput.value = '';
          if (hint) {
            hint.textContent = 'Only images up to 5MB are allowed';
            setTimeout(function () { hint.textContent = 'JPG/PNG · max 5MB'; }, 3000);
          }
          return;
        }
        compressImageFile(file, function (dataUrl) {
          if (!dataUrl) return;
          savedPhoto = dataUrl;
          if (photoPreview) { photoPreview.src = dataUrl; photoPreview.hidden = false; }
          if (photoRemove) photoRemove.hidden = false;
        });
      });
    }
    if (photoRemove) {
      photoRemove.addEventListener('click', function () { clearPhoto(); });
    }

    if (starPicker && ratingInput) {
      var starBtns = starPicker.querySelectorAll('.hrev__star-btn');
      function paintStars(val) {
        starBtns.forEach(function (b) {
          b.classList.toggle('is-active', parseInt(b.getAttribute('data-star'), 10) <= val);
        });
      }
      starPicker.addEventListener('click', function (e) {
        var b = e.target.closest('[data-star]');
        if (!b) return;
        var val = parseInt(b.getAttribute('data-star'), 10);
        ratingInput.value = String(val);
        paintStars(val);
      });
      starPicker.addEventListener('mouseover', function (e) {
        var b = e.target.closest('[data-star]');
        if (b) paintStars(parseInt(b.getAttribute('data-star'), 10));
      });
      starPicker.addEventListener('mouseleave', function () {
        paintStars(parseInt(ratingInput.value, 10) || 5);
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }
        var fd = new FormData(form);
        var nameVal = (fd.get('contact[name]') || 'Customer').toString();
        var cityVal = (fd.get('contact[city]') || '').toString().trim();
        var bodyVal = (fd.get('contact[body]') || '').toString();
        var titleVal = (fd.get('contact[review_title]') || '').toString();
        var ytVal = (fd.get('contact[youtube_url]') || '').toString().trim();
        var rateVal = parseInt((fd.get('contact[rating]') || '5').toString(), 10) || 5;
        var photoVal = savedPhoto;

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sending…';
        }

        fetch('/contact', { method: 'POST', body: fd, headers: { Accept: 'text/html' } })
          .catch(function () { /* offline: still thank user */ })
          .finally(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = 'Submit review';
            }
            form.hidden = true;
            if (thanks) thanks.hidden = false;

            var pendingReview = {
              id: handle + '-local-' + Date.now(),
              name: nameVal,
              city: cityVal || 'You',
              rating: rateVal,
              title: titleVal,
              body: bodyVal,
              date: new Date().toISOString(),
              verified: false,
              helpful: 0,
              photo: photoVal || null,
              youtube: ytVal || ''
            };
            var store = getLocalPending(handle);
            store.unshift(pendingReview);
            saveLocalPending(handle, store);
            pendingReview.date = new Date(pendingReview.date);
            pendingReview.pending = true;
            pending.unshift(pendingReview);
            rebuild();
            visible = Math.max(visible, 6);
            render();
          });
      });
    }

    render();
    var lastBlocksSig = JSON.stringify(window.__HREV_BLOCKS || []);
    function refreshBlocks() {
      var sig = JSON.stringify(window.__HREV_BLOCKS || []);
      if (sig === lastBlocksSig) return false;
      lastBlocksSig = sig;
      blocks = readBlocks();
      rebuild();
      render();
      return true;
    }
    window.HorizonReviews = {
      getReviews: function () { return reviews.slice(); },
      refreshBlocks: refreshBlocks
    };

    if (window.Shopify && Shopify.designMode) {
      var editorEvents = ['shopify:section:load', 'shopify:section:select', 'shopify:block:select', 'shopify:block:deselect', 'shopify:block:change'];
      editorEvents.forEach(function (evtName) {
        document.addEventListener(evtName, function () {
          setTimeout(refreshBlocks, 60);
        });
      });
    }
  }

  var productsCache = null;
  function fetchProducts() {
    if (productsCache) return Promise.resolve(productsCache);
    return fetch('/products.json?limit=240', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        productsCache = (j.products || []).map(function (p) {
          return {
            id: p.id,
            handle: p.handle,
            title: p.title,
            image: p.image ? p.image.src : ((p.images && p.images[0] && p.images[0].src) || ''),
            price: p.variants && p.variants[0] ? p.variants[0].price : ''
          };
        });
        return productsCache;
      })
      .catch(function () { return (productsCache = []); });
  }

  function timeAgoLabel(mins) {
    if (mins < 1) return 'Just now';
    if (mins < 60) return mins + ' min ago';
    var h = Math.floor(mins / 60);
    return h + (h === 1 ? ' hour ago' : ' hours ago');
  }

  function sessionPopupCount() {
    try {
      return parseInt(sessionStorage.getItem('hsoc_popups') || '0', 10);
    } catch (e) {
      return 0;
    }
  }

  function bumpSessionPopupCount() {
    try {
      sessionStorage.setItem('hsoc_popups', String(sessionPopupCount() + 1));
    } catch (e) { /* ignore */ }
  }

  function showOrderPopup(data, isReal) {
    if (document.hidden && isReal) return;
    var old = document.querySelector('.hsoc-popup');
    if (old) old.remove();

    var el = document.createElement('div');
    el.className = 'hsoc-popup' + (isReal ? ' hsoc-popup--real' : '');
    el.setAttribute('role', 'status');
    var img = data.image
      ? '<span class="hsoc-popup__thumb"><img src="' + esc(data.image) + '" alt="" width="56" height="56" loading="lazy"></span>'
      : '';
    var ago = isReal ? 'Just now' : timeAgoLabel(typeof data.mins === 'number' ? data.mins : 1 + Math.floor(Math.random() * 14));
    var badge = isReal ? '<span class="hsoc-popup__live">● Just ordered</span>' : '<span class="hsoc-popup__ago">' + ago + '</span>';
    var name = esc(data.buyer || (pick(Math.random, FIRST_NAMES)));
    var city = esc(data.city || pick(Math.random, CITIES));
    var t = esc(data.title || '');
    el.innerHTML =
      '<button type="button" class="hsoc-popup__close" aria-label="Close">×</button>' +
      img +
      '<span class="hsoc-popup__body">' +
      badge +
      '<span class="hsoc-popup__line"><strong>' + name + '</strong> from ' + city + ' bought</span>' +
      '<a class="hsoc-popup__link" href="' + esc(data.url || '#') + '">' + t + '</a>' +
      '<span class="hsoc-popup__stars">★★★★★ <span>Verified purchase</span></span>' +
      '</span>';

    document.body.appendChild(el);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-in'); });
    });

    var closed = false;
    function dismiss() {
      if (closed) return;
      closed = true;
      el.classList.remove('is-in');
      el.classList.add('is-out');
      setTimeout(function () { el.remove(); }, 420);
    }
    el.querySelector('.hsoc-popup__close').addEventListener('click', dismiss);
    var timer = setTimeout(dismiss, 8500);
    el.addEventListener('mouseenter', function () { clearTimeout(timer); });
    el.addEventListener('mouseleave', function () { timer = setTimeout(dismiss, 4000); });

    var link = el.querySelector('.hsoc-popup__link');
    if (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        dismiss();
        window.location.href = link.getAttribute('href');
      });
    }
  }

  function scheduleFakePopup() {
    if (!POPUPS_ENABLED) return;
    if (sessionPopupCount() >= MAX_POPUPS) return;
    var delay = 20000 + Math.random() * 70000;
    setTimeout(function () {
      if (!document.hidden && sessionPopupCount() < MAX_POPUPS) {
        fetchProducts().then(function (list) {
          if (!list.length) { scheduleFakePopup(); return; }
          var p = list[Math.floor(Math.random() * list.length)];
          bumpSessionPopupCount();
          showOrderPopup({
            buyer: pick(Math.random, FIRST_NAMES) + ' ' + pick(Math.random, LAST_NAMES),
            city: pick(Math.random, CITIES),
            title: p.title,
            image: p.image,
            url: '/products/' + p.handle,
            mins: 1 + Math.floor(Math.random() * 20)
          }, false);
          scheduleFakePopup();
        });
      } else {
        scheduleFakePopup();
      }
    }, delay);
  }

  function initRealtime() {
    var key = CFG.ablyKey || '';
    var channelName = CFG.ablyChannel || 'horizon-orders';
    if (!POPUPS_ENABLED || !key) return;

    function attach(ABLY) {
      try {
        var client = new ABLY.Realtime({ key: key, transports: ['websocket', 'polling'] });
        var ch = client.channels.get(channelName);
        ch.subscribe('order', function (msg) {
          var d = msg.data || {};
          fetchProducts().then(function (list) {
            var match = null;
            if (d.product_id) {
              for (var i = 0; i < list.length; i++) {
                if (list[i].id === d.product_id) { match = list[i]; break; }
              }
            }
            if (!match && d.title) {
              var lt = d.title.toLowerCase();
              for (var j = 0; j < list.length; j++) {
                if (list[j].title.toLowerCase().indexOf(lt) !== -1 || lt.indexOf(list[j].title.toLowerCase()) !== -1) {
                  match = list[j];
                  break;
                }
              }
            }
            if (!match) return;
            showOrderPopup({
              buyer: d.buyer || '',
              city: d.city || 'Pakistan',
              title: match.title,
              image: match.image,
              url: '/products/' + match.handle
            }, true);
          });
        });
      } catch (e) { /* ignore */ }
    }

    if (window.Ably) {
      attach(window.Ably);
    } else {
      var s = document.createElement('script');
      s.src = 'https://cdn.ably.com/lib/ably.min-2.js';
      s.async = true;
      s.onload = function () { attach(window.Ably); };
      document.head.appendChild(s);
    }
  }

  function boot() {
    initReviews();
    if (POPUPS_ENABLED) scheduleFakePopup();
    initRealtime();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var statsCache = {};
  function reviewStats(handle, title) {
    if (!handle) return null;
    if (statsCache[handle]) return statsCache[handle];
    try {
      var forced = window.__HREV_STATS && window.__HREV_STATS[handle];
      if (forced) {
        statsCache[handle] = forced;
        return forced;
      }
      var list = generateReviews(handle, title || '', null);
      var pendingN = getLocalPending(handle).length;
      var blockN = (window.__HREV_BLOCKS || []).length;
      var sum = 0;
      for (var i = 0; i < list.length; i++) sum += list[i].rating;
      var base = list.length;
      statsCache[handle] = {
        count: base + blockN + pendingN,
        avg: base ? Math.max(4.5, sum / base) : 5
      };
    } catch (e) {
      statsCache[handle] = null;
    }
    return statsCache[handle];
  }

  window.HorizonSocial = {
    showOrderPopup: showOrderPopup,
    fetchProducts: fetchProducts,
    reviewStats: reviewStats,
    config: CFG
  };
})();
